<div class="bg-white dark:bg-gray-800 dark:shadow-none rounded-2xl  overflow-hidden">
  <!-- Header -->
  <div class="px-6 py-4 text-lg font-semibold border-b border-gray-200 dark:border-gray-700">
    Reports
  </div>

  <!-- Column Headings -->
  <div
    class="grid grid-cols-[30%_70%] text-sm font-semibold uppercase tracking-wide border-b border-gray-200 dark:border-gray-700">
    <div class="px-6 py-3 text-gray-700 dark:text-gray-300">Report Name</div>
    <div class="px-6 py-3 text-gray-700 dark:text-gray-300">Description</div>
  </div>

  <!-- Rows -->
  <div *ngFor="let report of reports"
    class="grid grid-cols-[30%_70%] hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200">
    <!-- Report Name -->
    <div class="px-6 py-4">
      <a [routerLink]="[report.link]" class="text-blue-600 dark:text-blue-400 hover:underline">
        {{ report.name }}
      </a>

    </div>

    <!-- Description -->
    <div class="px-6 py-4 text-gray-600 dark:text-gray-400">
      {{ report.description }}
    </div>
  </div>
</div>